/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 17:12:05
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface EAFRegisterListParams {
  startDateStart?: any
  startDateEnd?: any
  current?: any
  size?: any
  deviceName?: any
  deviceNumber?: any
  tenantId?: any
}

export function getEAFRegisterList(params: EAFRegisterListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevice/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}

// 详情
export function getEAFRegisterDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevice/detail`,
    method: 'GET',
    params,
  }
}

// 导出
export function getEAFRegisterExport(params: EAFRegisterListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevice/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  location?: any
  deviceNumber?: any
  deviceName?: any
  model?: any
  factoryNumber?: any
  productionDate?: any
  purchaseDate?: any
  scrapDate?: any
  startDate?: any
  factoryName?: any
  supplierEnterprise?: any
  contactPerson?: any
  contactPhone?: any
  quantity?: any
  price?: any
  amount?: any
  productionLicenseNumber?: any
  registrationCertificateNumber?: any
  executionStandardNumber?: any
  maintenanceUser?: any
  maintenanceUserName?: any
  administrator?: any
  administratorName?: any
  generalInspectionCycle?: any
  mandatoryInspectionCycle?: any
  usage?: any
  serviceLife?: any
  remark?: any
}

export function getEAFRegisterSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevice/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdevice/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
